import * as React from "react";
import { Input } from "./SpecInput";
import { useForm } from "react-hook-form";
import { TableCell, TableRow } from "@mui/material";
import { SpecForm } from "./SpecRow";
import { useInjector } from "@bb-vendure/admin-ui/react";
import { NotificationService } from "@bb-vendure/admin-ui/core";
import { useAddSpec } from "./graphql/Add-Spec";
import useUpdateSpec from "./graphql/Update-Spec";

export type SpecFormValue = {
  Key: string;
  Value: string;
};
const SpecRowInputForm = (props: {
  id: string;
  cancel: any;
  data: any;
  editId?: string | null;
  defaultInfor?: {
    name: string;
    value: string;
  };
}) => {
  const notificationService = useInjector(NotificationService);
  const specsData = props.data.getSpecsByProductVariantId as SpecForm[];
  let defaultValue = {
    Key: "",
    Value: "",
  };
  let editItem: SpecForm;
  if (props.editId) {
    specsData.find((item) => {
      if (item.id === props.editId) {
        editItem = item;
        defaultValue = {
          Key: item.name,
          Value: item.value,
        };
      }
    });
  }

  if (props.defaultInfor) {
    defaultValue = {
      Key: props.defaultInfor.name,
      Value: props.defaultInfor.value,
    };
  }

  const [addSpec] = useAddSpec();
  const [updateSpec] = useUpdateSpec();
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
    reset,
  } = useForm<SpecFormValue>({
    defaultValues: defaultValue,
    mode: "onChange",
  });

  const onSubmit = async (data) => {
    let isKeyExists = false;
    specsData.forEach((item) => {
      if (item.name === data.Key) {
        isKeyExists = true;
      }
    });

    if (props.editId) {
      const spec = {
        id: props.editId,
        name: data.Key,
        value: data.Value,
        productVariantId: props.id,
      };

      const res = await updateSpec({
        input: spec,
      });

      if (res) {
        notificationService.success("Spec updated successfully");
      }
    } else {
      if (isKeyExists) {
        notificationService.error("Key already exists");
        setError("Key", {
          type: "manual",
          message: "Key already exists",
        });
        return;
      }
      const newSpec = {
        productVariantId: props.id,
        name: data.Key,
        value: data.Value,
      };

      const res = await addSpec({
        input: newSpec,
      });

      if (res) {
        notificationService.success("Spec added successfully");
      }
    }
    props.cancel();
  };

  React.useEffect(() => {
    reset({ ...defaultValue });
  }, [props.defaultInfor]);

  return (
    <TableRow>
      <TableCell sx={{ fontSize: "16px" }}></TableCell>
      <TableCell>
        <Input
          control={control}
          name="Key"
          rules={{ required: "Key is required" }}
        />
      </TableCell>
      <TableCell>
        <Input
          control={control}
          name="Value"
          rules={{ required: "Value is required" }}
        />
      </TableCell>
      <TableCell>
        <form onSubmit={handleSubmit(onSubmit)}>
          <button className="button-ghost" type="submit">
            {props.editId ? <>Update</> : <>Add</>}
          </button>
          <button className="button-ghost" onClick={props.cancel} type="button">
            Cancel
          </button>
        </form>
      </TableCell>
    </TableRow>
  );
};

export default SpecRowInputForm;
